module.exports = __webpack_public_path__ + "przelewy24.png?26d390d2759e80ce598ec9f779eb0157";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/przelewy24.png
// module id = z+2j
// module chunks = 50